import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { GaeUser } from './my.service';
import { SearchResult } from '../data/search-result';

@Injectable({
    providedIn: 'root'
})
export class AdminService {

    constructor(private http: HttpClient) { }

    getInvoiceRequestedUser(): Observable<SearchResult<GaeUser>> {
        return this.http.get<SearchResult<GaeUser>>(environment.apiUrl + '/v1/admin/invoice-requested-users');
    }

    approvalInvoiceRequest(gaeUserId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/admin/invoice-requested-users/" + gaeUserId + "/approval", {});
    }

    getUsers(queryParams: HttpParams): Observable<SearchResult<GaeUser>> {
        return this.http.get<SearchResult<GaeUser>>(environment.apiUrl + '/v1/admin/users');
    }

    getPlans(): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl + '/v1/admin/plans');
    }

    evictPlanCache(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/admin/plans/evict-cache", {});
    }

    deleteUser(gaeUserId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/admin/users/" + gaeUserId + "/disable", {});
    }

    cancelDeleteUser(gaeUserId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/admin/users/" + gaeUserId + "/enable", {});
    }

    sendContact(params: any): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/contact", params);
    }

}